var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.77v4.355m-7.125 9.5v-3.167 3.167zm0-3.167v-9.5a1.583 1.583 0 011.583-1.583h5.146l.792.792h6.729l-2.375 4.75 2.375 4.75h-6.73l-.79-.792H2.957a1.583 1.583 0 00-1.583 1.583v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/flag.04aab3d3.svg";
export { SvgFlag as ReactComponent };